import axios from 'axios';
import { Service, TextosMarca, TextosMarcaResponse } from './consultar-textos-por-marca.types';

export const consultarTextosPorMarcaService: Service = async ({ urlBase, domain, brand }) => {
  const { data } = await axios.get<TextosMarcaResponse>(`${urlBase}/marca/${brand}/textos`, {
    timeout: 9000,
  });

  const dataMap = new Map<string, TextosMarca>().set('aluno', data.aluno).set('educador', data.educador);

  return dataMap.get(domain);
};
